<template>
    <div id="sub-content" class="s-inner">
    
    <h3>채용공고</h3>
    <div class="sub-board-view sub-recruit-view">
        <div class="tit-box">
            <p class="subject" v-text="state.boardDetailItems.Title"></p>
            <ul>
                <li>
                    <dl>
                        <dt>작성일</dt>
                        <dd v-text="state.boardDetailItems.CreateDate"></dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>조회수</dt>
                        <dd v-text="state.boardDetailItems.Hit"></dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>구분</dt>
                        <dd v-if="state.boardDetailItems.CodeVal === 'CD021001'"><span class="cate case1">신입</span></dd>
                        <dd v-if="state.boardDetailItems.CodeVal === 'CD021002'"><span class="cate case2">경력</span></dd>
                        <dd v-if="state.boardDetailItems.CodeVal === 'CD021003'"><span class="cate case3">상시</span></dd>
                    </dl>
                </li>
            </ul>
        </div>
        <div class="content-box">   
            <div id="board-view-wrap">
                <p><span v-html="state.boardDetailItems.Content"></span></p>       
            </div>

            <ul class="file-box">
                <li v-for="file in state.attFiles" :key="file.FileSeq">
                    <a href='javascript:void(0)' @click="eventHandler.downloadFile(file)" class="file">{{ file.FileNm }} <span>({{ file.FileSize }})</span></a>           
                </li>
             </ul>

            <a href="javascript:;" title="입사지원서 작성 바로가기" class="koreit-btn1 case3 auto mt50"
            v-if="state.isValid == 'Y'" @click="methods.moveApply">입사지원서 작성 바로가기</a>
        </div>
    </div>

    <a href="javascript:;" @click="eventHandler.moveList" title="목록으로" class="koreit-btn1 auto mt70">목록으로</a>

</div>
</template>
<script>
import { reactive } from '@vue/reactivity';
import { inject } from 'vue';
import { board } from '@/modules/recruit/board.js';
import { onMounted } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { useRoute } from "vue-router";
import router from '@/router'
import alertManager from '@/utils/alert-confirm-manager'; 
import axios from 'axios';
import { common } from '@/modules/common.js';
export default {
    setup() {
        // 공유 상태값 주입
        let shareState = inject('shareState');

        // 라우트
        const route = useRoute();

        // 스토어
        const store = useStore();

        // state(변수)
        const state = reactive({

            parameter:{
                // 시퀀스
                Seq: route.query.Seq,
                // 시스템코드
                SystCode: 'ADM',
                // 게시판 카테고리
                BoardCategory: 'RECCM001',
                // 그룹 번호
                GroupNo: 0,
                Title: '',
                Content: '',
                UseYn: 'Y',
                UserName: '',
                UserNo: '',
                CodeVal: '',  
            },

            // 채용공고 데이터
            boardDetailItems: new Object(),

            // 채용공고 파일 데이터
            attFiles: [],

            //게시판 설정 정보
            defaults: {},

            // 이전글 데이터
            prevData: new Object(),
            
            // 다음글 데이터
            nextData: new Object(),

            // 마감여부
            isValid: 'N',
        });

        // 메소드
        const methods = {

            // 채용공고 정보 가져오기
            getBoardDetail: () => {

                // 스토어 값 변경
                store.commit("setLoadingStatus", true)

                // 게시글 상세 조회
                board.getBoardDetail(JSON.stringify(state.parameter)).then(result => {

                    state.boardDetailItems = result.Table.rows[0];
                    state.attFiles = !!result.Table1.rows[0] ? result.Table1.rows : null;

                    // 마감여부 '진행'일 때 지원서 수정 버튼 보이기
                    if (state.boardDetailItems.IsValid == 'Y') state.isValid = 'Y'

                }).finally(() => {

                    // 스토어 값 변경
                    store.commit("setLoadingStatus", false)

                    // 게시글 이전글 다음글 조회
                    methods.getKRTBoardContentPreNext()
                })                
            },

            // 이전글 다음글 조회 메서드
            getKRTBoardContentPreNext: () => {

                // 스토어 값 변경
                store.commit("setLoadingStatus", true)

                // 이전글 다음글 조회
                board.getKRTBoardContentPreNext(JSON.stringify(state.parameter)).then((result) => {

                    if (result.Table1.rows.length > 0) {

                        let prev = result.Table1.rows.filter((val) => val.CodeVal !== 'CD021003');
                        state.prevData = prev[0]
                    }
                    else {

                        state.prevData = new Object()
                    }
                    
                    if (result.Table.rows.length > 0) {

                        let next = result.Table.rows.filter((val) => val.CodeVal !== 'CD021003');
                        state.nextData = next[0]
                    }
                    else {

                        state.nextData = new Object()
                    }
                }).finally(() => {

                    // 스토어 값 변경
                    store.commit("setLoadingStatus", false)
                })
            },

            // 입사지원서 작성 메서드
            moveApply: (e) => {

                // 진입경로 저장
                localStorage.clear();
                localStorage.setItem('BeforeRoute', 'careers');

                const q = route.query;
                q["Seq"] = state.parameter.Seq;   
                q["FORM_NO"] = state.boardDetailItems.FORM_NO;
                router.push({ name: 'Apply', query: q });
            }
        }

        // 이벤트 핸들러
        const eventHandler = {

            // 첨부파일 다운로드
            downloadFile: (file) => {

                const url = process.env.VUE_APP_FILE_UPDOWNLOAD_HANDLER_BASE_DIR + store.getters.fileDownloadUrl;
                const formData = new FormData();

                formData.append("VIRDIR", file.FilePath);

                axios.post(url, formData, {
                    responseType: 'blob',
                }).then(response => {

                    // 파일 유효성 검사
                    if (!response.headers["content-disposition"]) {

                        // 실패 토스트
                        alertManager.toast.custom('warning', '파일을 다운로드 하는데 실패하였습니다. \n 관리자에게 문의하세요.');
                        return;
                    }

                    // 진행 토스트
                    alertManager.toast.fileDownloading();

                    //onDeleteClick 다운로드(서버에서 전달 받은 데이터) 받은 바이너리 데이터를 blob으로 변환
                    const blob = new Blob([response.data]);

                    // blob을 사용해 객체 URL을 생성
                    const fileUrl = window.URL.createObjectURL(blob);

                    // 다운로드 파일명
                    const fileName = response.headers["content-disposition"].split("filename=")[1].replace(/"/g, "");

                    // blob 객체 URL을 설정할 링크 생성
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.style.display = 'none';
                    link.download = decodeURI(fileName);

                    // 링크를 body에 추가하고 강제로 click 이벤트를 발생시켜 파일 다운로드를 실행
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    // 다운로드가 끝난 리소스(객체 URL)를 해제
                    window.URL.revokeObjectURL(fileUrl);

                    // 완료 토스트
                    alertManager.toast.fileDownloaded();
                });
            },

            // 이전글로 이동
            movePrev: () => {

                if (!!state.prevData) {
                    
                    router.push({
                        name: 'CareersView',
                        query: {
                            Seq: state.prevData.Seq
                        }
                    });
                }
                else {

                    alertManager.alert.warning("마지막 글입니다.");
                }
            },
            
            // 다음글로 이동
            moveNext: () => {

                if (!!state.nextData) {

                    router.push({
                        name: 'CareersView',
                        query: {
                            Seq: state.nextData.Seq
                        }
                    });
                }
                else {

                    alertManager.alert.warning("마지막 글입니다.");
                }
            },

            // 목록으로 이동
            moveList: () => {

                router.push({ name: 'Careers'});
            },
        }

        // Dom 객체 그려진 이후 hook
        onMounted(() => {

            // 현재 서브타이틀 정보 설정
            shareState.items = common.getSubTitleElement(route.path)

            // 채용공고 가져오기
            methods.getBoardDetail();
        });

        return {
            state,
            store,
            eventHandler,
            methods,
            common,
            shareState,
        }
    },
}
</script>